// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"xt-z","mainContent":"yt-z","activeSidebar":"zt-z"};